import styled, { keyframes } from 'styled-components';

const SPINNER_NUM_FRAMES = 72;
const SPINNER_SIZE = 300;

const SpinnerCenteredContainer = styled.div`
  flex: 1;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const spinnerAnimation = keyframes`
  0% { transform: translateY(0px); }
  100% { transform: translateY(${-1 * SPINNER_SIZE * SPINNER_NUM_FRAMES}px); }
`;
export const SpinnerAnimate = styled.div`
  width: ${SPINNER_SIZE}px;
  height: ${SPINNER_SIZE}px;
  overflow: hidden;
  position: relative;
  transform: scale(0.6);

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: ${SPINNER_SIZE}px;
    height: ${SPINNER_SIZE * SPINNER_NUM_FRAMES}px;
    background-image: url('/public/spinner-spritesheet.png');
    animation-name: ${spinnerAnimation};
    animation-timing-function: steps(${SPINNER_NUM_FRAMES});
    animation-duration: ${SPINNER_NUM_FRAMES * 20}ms;
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }
`;

export const FullViewportSpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.white};

  /**
   * Trying to be as responsible as possible with the z-index value here...
   * The z-index value of the mobile SideMenu and mobile/desktop main nav header is 1000.
   */
  z-index: 1001;

  /* The Spinner component's inner container */
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  /* The Spinner component's main element */
  ${({ theme }) => theme.mediaQueries.large} {
    & > div > div {
      transform: scale(1);
    }
  }

  ${({ theme }) => theme.mediaQueries.small} {
    & > div > div {
      transform: scale(0.8);
    }
  }

  /** Default (in this case, mobile) is scale(0.6) */
`;

export const SpinnerCenteredInContainer = ({ className }: Pick<SpinnerProps, 'className'>) => (
  <SpinnerCenteredContainer className={className}>
    <SpinnerAnimate />
  </SpinnerCenteredContainer>
);
